<template>
  <PaOverlayModal
   :appendClass="['pa-overlay-modal-default-transition', 'pa-connection-add-cofirm-modal']"
   :additionalZIndex="2"
   :isOpen="isOpenModal"
   :position="{top: .15}"
   :isFreez="isFreezModal"
   contentTransitionName="trans-content"

   @closeOverlayModal="handleCloseOverlay"
  >
    <PaWideModalBox
     :confirmButtonText="buttonText"
     :isSubmitLoading="isSubmitLoading"

     @handleSubmit="handleClickSubmitButton"
     @handleCancel="handleClickCancelButton"
    >
      <template v-slot:title>{{title}}</template>
      <template v-slot:description>{{description}}</template>
      <template v-slot:caption>{{caption}}</template>
      <template v-slot:messageTitle><span class="bold">―</span>&nbsp;御注意事項&nbsp;<span class="bold">―</span></template>
      <template v-slot:message>{{message}}</template>
    </PaWideModalBox>
  </PaOverlayModal>
</template>

<script>
import PaOverlayModal from '@/components/Parts/PAOverlayModal/PAOverlayModal.vue'
import PaWideModalBox from '@/components/Parts/PAWideModalBox/PAWideModalBox.vue'

import {LeavePodRoom, BrokePodRoom} from '@/graphql/mutations/Pod.graphql'
import {GetPodRoomList} from '@/graphql/queries/ConnectionPod.graphql'

export default {
  components : {
    PaOverlayModal,
    PaWideModalBox
  },

  data(){
    return {
      title           : '',
      description     : '',
      caption         : '',
      message         : '',
      buttonText      : '',

      storyScripts    : {
        leave : {
          title         : 'ポットから離脱する',
          description   : '「[[name]]」から離脱します。よろしいですか？',
          caption       : '離脱するために消費されるアイテムはありません。',
          message       : '一度離脱するとこのポットに再度参加することは出来ません。このポットに再参加するためにはポット作成者から投入される必要があります。ポットを離脱してもポット内で使用されたアイテム等は一切返却されません。',
          buttonText    : 'このポットから離脱する'
          // messageTitle  : '御注意事項', // これは共通して同じ内容なのでいらない
        },

        broke : {
          title         : '塔経市帝不要物回収センター',
          description   : '毎度御利用いただきまして有難う御座います。弊センターが責任を持って「[[name]]」を溶解処理致します。よろしいですか？',
          caption       : 'ポットを壊すために消費されるアイテムはありません。',
          message       : '一度ポットを壊すと塔経市帝不要物回収センターによって即座に溶解処分されますのでポットを元に戻すことは出来ません。ポットを壊してもポット内で使用されたアイテム等は一切返却されません。',
          buttonText    : 'ポットの処分を依頼する'
          // messageTitle  : '御注意事項', // これは共通して同じ内容なのでいらない
        }
      },

      executeRefetchRequest : false
    }
  },

  computed : {
    isOpenModal(){
      return this.$store.state.connectionLeaveModal.isOpenModal;
    },

    isFreezModal(){
      return this.$store.state.connectionLeaveModal.isFreezModal;
    },

    isSubmitLoading(){
      return this.$store.state.connectionLeaveModal.isSubmitLoading;
    },

    behaviour(){
      return this.$store.state.connectionLeaveModal.behaviour;
    },

    podRoom(){
      return this.$store.state.connectionLeaveModal.podRoom;
    },

    podRoomType(){
      return this.$store.state.connection.podRoomType;
    }
  },

  apollo : {
    joinedPodRoomList : {
      query : GetPodRoomList,
      variables(){
        return {
          roomType  : this.podRoomType
        };
      },
      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    }
  },

  watch : {
    behaviour : {
      handler(){
        this.updateTextData();
      },
      immediate: true
    },

    podRoom : {
      handler(data){
        if(typeof data === 'undefined') return;
        if(data === null) return;

        this.updateTextData();
      },
      immediate: true,
      deep: true
    },

    joinedPodRoomList : {
      handler(data){
        if(this.executeRefetchRequest === false) return;
        if(typeof data === 'undefined') return;

        if(typeof this.joinedPodRoomList[0] !== 'undefined'){
          this.$store.dispatch({
            type        : 'connection/updatePodRoomId',
            podRoomType : this.podRoomType,
            podRoomId   : this.joinedPodRoomList[0].id,
          });
          
          this.executeRefetchRequest = false;
        }
      }
    }
  },

  methods : {
    updateTextData(){
      this.title        = this.textReplacer(this.storyScripts[this.behaviour].title, this.podRoom);
      this.description  = this.textReplacer(this.storyScripts[this.behaviour].description, this.podRoom);
      this.caption      = this.textReplacer(this.storyScripts[this.behaviour].caption, this.podRoom);
      this.message      = this.textReplacer(this.storyScripts[this.behaviour].message, this.podRoom);
      this.buttonText   = this.textReplacer(this.storyScripts[this.behaviour].buttonText, this.podRoom);
    },

    closeModal(){
      this.$store.dispatch({
        type            : 'connectionLeaveModal/updateModal',
        isOpen          : false,
        isFreezModal    : false,
        isSubmitLoading : false,
        behaviour       : 'leave',
        podRoom         : null,
      });
    },

    handleCloseOverlay(){
      this.closeModal();
    },

    async handleClickSubmitButton(){
      this.$store.dispatch({
        type            : 'connectionLeaveModal/updateModal',
        isSubmitLoading : true,
      });

      await this.UXWaiting(3000);

      switch(this.behaviour){
        case 'leave':
          await this.executeLeavePodRoom();
        break;

        case 'broke':
          await this.executeBrokePodRoom();
        break;
      }

      this.closeModal();
    },

    executeLeavePodRoom(){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : LeavePodRoom,
          variables : {
            podRoomId  : this.podRoom.id
          },
          update    : (store, {data: {LeavePodRoom: {status}}}) => {
            if(status === false){
              this.$store.dispatch({
                type        : 'flashMessage/updateFlashMessage',
                hasMessage  : true,
                message     : '&nbsp;エラーが発生しました。',
                status      : 'error',
                hasControl  : true,
                autoClose   : 8000
              }, {root:true});
            }else{
              this.$store.dispatch({
                type        : 'flashMessage/updateFlashMessage',
                hasMessage  : true,
                message     : '&nbsp;ポッドルーム「'+this.podRoom.name+'」から離脱しました。',
                status      : 'success',
                hasControl  : true,
                autoClose   : 8000
              }, {root:true});

              this.resetPrivatePodRoomIndex();
            }
          }
        }).then(async () => {
          resolve(true);
        }).catch(async (error) => {
          console.error(error);

          resolve(false);
        });
      });
    },

    executeBrokePodRoom(){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : BrokePodRoom,
          variables : {
            podRoomId  : this.podRoom.id
          },
          update    : (store, {data: {BrokePodRoom: {status}}}) => {
            if(status === false){
              this.$store.dispatch({
                type        : 'flashMessage/updateFlashMessage',
                hasMessage  : true,
                message     : '&nbsp;エラーが発生しました。',
                status      : 'error',
                hasControl  : true,
                autoClose   : 8000
              }, {root:true});
            }else{
              this.$store.dispatch({
                type        : 'flashMessage/updateFlashMessage',
                hasMessage  : true,
                message     : '&nbsp;ポッドルーム「'+this.podRoom.name+'」を融解処理致しました。',
                status      : 'success',
                hasControl  : true,
                autoClose   : 8000
              }, {root:true});

              this.resetPrivatePodRoomIndex();
            }
          }
        }).then(async () => {
          resolve(true);
        }).catch(async (error) => {
          console.error(error);

          resolve(false);
        });
      });
    },

    resetPrivatePodRoomIndex(){
      this.executeRefetchRequest = true;
      this.$apollo.queries.joinedPodRoomList.refetch();
    },

    handleClickCancelButton(){
      this.closeModal();
    }
  },
  mounted(){
    this.executeRefetchRequest = false;
  }
}
</script>